import {
  Hotel as HotelIcon,
  DirectionsCar as CarIcon,
  Flight as FlightIcon,
  DirectionsBoat as FerryIcon,
  Forest as NatureIcon,
  Tour as TourIcon,
  LocalSee as SightseeingIcon,
  Restaurant as MealIcon,
  LocalCafe as DrinkIcon,
  SelfImprovement as MeditationIcon,
  FilterAlt as DefaultIcon,
  Star as StarIcon
} from '@mui/icons-material';

export const getStepIcon = (type, iconProps = {}) => {
  const defaultIconProps = { sx: { color: 'white', fontSize: '1.2rem' } };
  const props = { ...defaultIconProps, ...iconProps };

  switch (type) {
    case 'quest':
      return <StarIcon {...props} />;
    case 'lodging':
      return <HotelIcon {...props} />;
    case 'car':
      return <CarIcon {...props} />;
    case 'flight':
      return <FlightIcon {...props} />;
    case 'ferry':
      return <FerryIcon {...props} />;
    case 'nature':
      return <NatureIcon {...props} />;
    case 'tour':
      return <TourIcon {...props} />;
    case 'sightseeing':
      return <SightseeingIcon {...props} />;
    case 'meal':
      return <MealIcon {...props} />;
    case 'drink':
      return <DrinkIcon {...props} />;
    case 'meditation':
      return <MeditationIcon {...props} />;
    default:
      return <DefaultIcon {...props} />;
  }
};

export default getStepIcon;
